import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, nextTick } from '../../../../../adapter-vue';
import {
  IMessageModel,
  TUITranslateService,
} from '@tencentcloud/chat-uikit-engine';
import { getBoundingClientRectSync } from '@tencentcloud/universal-api';
import { convertor } from '../../../utils/convertVoiceToText';

interface IProps {
  message: IMessageModel;
  contentVisible: boolean;
  convertWrapperRef: HTMLDivElement | undefined;
  isSingleConvert?: boolean;
}

interface IEmits {
  (e: 'toggleErrorStatus', status: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'convert-content',
  props: {
    message: { default: () => ({} as IMessageModel) },
    contentVisible: { type: Boolean },
    convertWrapperRef: null,
    isSingleConvert: { type: Boolean, default: false }
  },
  emits: ["toggleErrorStatus"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'toggleErrorStatus', status: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { message: IMessageModel, contentVisible: boolean, convertWrapperRef: HTMLDivElement | undefined, isSingleConvert: boolean }




const convertFinished = ref<boolean>(false);
const convertText = ref<string>('');
const calculateHeight = ref<number>(0);
const calculateWidth = ref<number>(0);

const convertLoadingRef = ref<HTMLDivElement>();
const convertContentRef = ref<HTMLDivElement>();

watch(() => props.contentVisible, (newVal: boolean) => {
  if (newVal) {
    convertor.get(props.message)
      .then((text) => {
        convertFinished.value = true;
        convertText.value = text;
        nextTick(() => {
          const { height: originHeight, width: originWidth } = getBoundingClientRectSync(convertLoadingRef.value!);
          const { height, width } = getBoundingClientRectSync(convertContentRef.value!);
          calculateHeight.value = originHeight;
          calculateWidth.value = originWidth;
          requestAnimationFrame(() => {
            calculateHeight.value = height;
            calculateWidth.value = width;
            if (props.isSingleConvert) {
              nextTick(() => {
                const { bottom } = getBoundingClientRectSync(props.convertWrapperRef);
                const { bottom: bottomWindow } = getBoundingClientRectSync('#messageScrollList');
                if (bottom > bottomWindow) {
                  const timer = setTimeout(() => {
                    props.convertWrapperRef!.scrollIntoView({ block: 'end', behavior: 'smooth' });
                    clearTimeout(timer);
                  }, 150);
                }
              });
            }
          });
        });
      })
      .catch((err) => {
        convertFinished.value = true;
        emits('toggleErrorStatus', true);
        const { height: originHeight } = getBoundingClientRectSync(convertLoadingRef.value!);
        calculateHeight.value = originHeight;
        convertText.value = err.message;
      });
  }
}, {
  immediate: true,
});

return { __sfc: true,emits, props, convertFinished, convertText, calculateHeight, calculateWidth, convertLoadingRef, convertContentRef, TUITranslateService }
}

})